import React from 'react';
import cx from 'classnames';

import { Tag } from '../Typography';

import styles from './index.module.scss';

export enum BackgroundColor {
  RED = 'red',
  GREEN = 'green',
  GRADIENT = 'gradient',
  WHITE = 'white',
}

export interface BadgeProps {
  text: string;
  backgroundColor?: BackgroundColor;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  text,
  backgroundColor = BackgroundColor.GREEN,
  className,
}) => {
  return (
    <div
      className={cx(
        styles.wrapper,
        {
          [styles.red]: backgroundColor === BackgroundColor.RED,
          [styles.green]: backgroundColor === BackgroundColor.GREEN,
          [styles.gradient]: backgroundColor === BackgroundColor.GRADIENT,
          [styles.white]: backgroundColor === BackgroundColor.WHITE,
        },
        className,
      )}
    >
      <Tag className={styles.text}>{text}</Tag>
    </div>
  );
};

export default Badge;
